export default {
  API_URL_INDENTITY: process.env.REACT_APP_API_URL_IDENTITY,
  API_URL_LOCAIS: process.env.REACT_APP_API_URL_LOCAIS,
  API_URL_POLEPOSITION: process.env.REACT_APP_API_URL_POLEPOSITION,
  API_URL_NOTIFICATION: process.env.REACT_APP_API_URL_NOTIFICATION,
  API_URL_AGENDAMENTO: process.env.REACT_APP_API_URL_AGENDAMENTO,
  API_URL_USERS: process.env.REACT_APP_API_URL_IDENTITY,
  URL_ADMIN: process.env.REACT_APP_URL_ADMIN,
  API_URL_AGENDAMENTO_RESERVA: process.env.REACT_APP_API_URL_AGENDAMENTO_RESERVA,
  API_URL_SOCKET: process.env.REACT_APP_URL_API_HUB_NOTIFICACOES,
  API_URL_DATA_COMMON: process.env.REACT_APP_API_URL_DATA_COMMON,
};
